import logoFull from './logo/logo.svg?raw';
import logoMark from './logo/logo-mark.svg?raw';
import styles from './Logo.module.css';

type LogoProps = {
  /** Monogram only (no wordmark) — used in tight/mobile spots. */
  compact?: boolean;
};

/**
 * SorareAce brand logo — vectorized artwork inlined so it scales crisply and stays theme-aware:
 * the wordmark/monogram theme parts use `currentColor` (= --sa-header-fg), the accent uses
 * `--sa-color-primary`. One asset works on both the light and dark header. `compact` renders just
 * the "A/S" monogram for narrow layouts.
 */
const Logo = ({ compact = false }: LogoProps) => (
  <span
    className={compact ? styles.mark : styles.logo}
    role="img"
    aria-label="SorareAce"
    data-testid="sa-logo"
    dangerouslySetInnerHTML={{ __html: compact ? logoMark : logoFull }}
  />
);

export default Logo;
